import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedApi } from '../api';

const fetchEditors = async (authenticatedFetch, limit, offset, nameSearch = '', keywordSearch = '', publicationSearch = '') => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    offset: offset.toString()
  });
  
  if (nameSearch) {
    params.append('nameSearch', nameSearch);
  }
  if (keywordSearch) {
    params.append('keywordSearch', keywordSearch);
  }
  if (publicationSearch) {
    params.append('publicationSearch', publicationSearch);
  }
  
  const url = `${process.env.REACT_APP_API_URL || '/api'}/editors?${params.toString()}`;
  const response = await authenticatedFetch(url);
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  return response.json();
};

export const useEditors = (limit = 20, offset = 0, nameSearch = '', keywordSearch = '', publicationSearch = '', enabled = true) => {
  const { authenticatedFetch } = useAuthenticatedApi();

  return useQuery({
    queryKey: ['editors', limit, offset, nameSearch, keywordSearch, publicationSearch],
    queryFn: () => fetchEditors(authenticatedFetch, limit, offset, nameSearch, keywordSearch, publicationSearch),
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    retryDelay: 2000,
    enabled: !!authenticatedFetch && enabled, // Only run when authenticated and enabled
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });
};
